import './style.scss';
import { UserPost } from '../../types/posts';

interface AppUserPostProps {
	data: UserPost,
}

function AppUserPost({data}: AppUserPostProps) {
	return (
		<div className='app-user-post-wrap'>
			<div className='app-user-post-details-wrap'>
				<img 
					className='app-user-post-profile-img'
					src={data.sourceImgSrc}
					alt='Posters Profile'
				/>
				<div className='app-user-post-info'>
					<div className='app-user-post-name'>
						{data.sourceName.replace(' ', '.').toLowerCase()}
						{data.verified && 
							<img
								className='app-user-post-verify-tick'
								src='/imgs/icons/profile/icon-profile-verified-tick.svg'
								alt='Verified tick'
							/>
						}
					</div>
					<div className='app-user-post-time'>
						{data.postDate} Mins ago | <span className='app-user-post-community'>{data.community}</span>
					</div>
				</div>
			</div>
			<div className='app-user-post-content-wrap'>
				{data.postMsg}
			</div>
			{data.postImgSrc && 
				<div className='app-user-post-content-wrap'>
					<img
						className='app-user-post-img'
						src={data.postImgSrc}
						alt={`post_img_${data.postId}`}
					/>
				</div>
			}
			<div className='app-user-post-interaction-wrap'>
				<img
					className='app-user-post-interaction-icon'
					src='/imgs/icons/posts/icon-post-like.svg'
					alt='Post Like Button'
				/>
				<div className='app-user-post-interaction-number'>0</div>
				<img
					className='app-user-post-interaction-icon'
					src='/imgs/icons/posts/icon-post-comment.svg'
					alt='Post Comment Button'
				/>
				<div className='app-user-post-interaction-number'>0</div>
			</div>
		</div>
	)
}

export default AppUserPost
